import {
  Box,
  Card,
  ClickAwayListener,
  FormControlLabel,
  Stack,
  Typography,
} from "@mui/material";
import AntSwitch from "../../sharedComponent/AntSwitch";
import phoneIcon from "../../../assets/images/icon/phoneIcon.svg";
import mailIcon from "../../../assets/images/icon/mailIcon.svg";
import threeDotsIcon from "../../../assets/images/icon/threedots.png";
import editIcon from "../../../assets/images/icon/edit.png";
import deleteIcon from "../../../assets/images/icon/delete.png";
import ProfileAvatar from "../../user/ProfileAvatar";
import { useState } from "react";

interface Props {
  user: any;
  index?: number;
  // dropdownVisible: number | string | null,
  // setDropdownVisible: (a : any) => void,
  handleChangeSwitch: any;
  checked: any;
  openDeleteModal: any;
  openEditModal: any;
  allRoles?: any;
  // handleToggleDropdown: (a : any) => void,
}
const UserCardGrid = ({
  user,
  // dropdownVisible,
  // setDropdownVisible,
  handleChangeSwitch,
  checked,
  openDeleteModal,
  openEditModal,
  index,
  allRoles,
}: // handleToggleDropdown,
Props) => {
  const [dropdownVisible, setDropdownVisible] = useState<
    number | string | null
  >(null);

  const handleToggleDropdown = (id: any) => {
    setDropdownVisible((prevId) => (prevId === id ? null : id));
  };

  const getRoleNameByProfileId = (id: number) => {
    let a = allRoles.find((role: any) => role.profileId === id);
    if (a) {
      return a.profileName;
    } else {
      return "N/A";
    }
  };

  return (
    <Card
      className="userCard"
      style={{
        opacity: user.accountStatus === "ACTIVE" ? "1" : "0.4",
      }}
    >
      <Stack display="flex" flexDirection="row" alignItems="start">
        <Box style={{ width: "100%" }}>
          <Stack
            display="flex"
            flexDirection="row"
            alignItems="start"
            justifyContent="space-between"
            style={{ marginBottom: "20px", position: "relative" }}
          >
            <Stack
              display="flex"
              flexDirection="row"
              alignItems="start"
              gap="8px"
            >
              {user.profilePhoto ? (
                <img
                  src={user.profilePhoto}
                  alt="partner"
                  className="icon"
                  height={52}
                  width={52}
                />
              ) : (
                <ProfileAvatar
                  firstName={user.name}
                  lastName={user.lastName !== undefined ? user.lastName : ""}
                />
              )}
              <div>
                <Typography className="userName">
                  <div
                    style={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      maxWidth: "130px",
                    }}
                    title={`${user.name} ${
                      user.lastName !== undefined ? user.lastName : ""
                    }`}
                  >
                    {`${user.name} ${
                      user.lastName !== undefined ? user.lastName : ""
                    }`}
                  </div>
                </Typography>
                <span className="bottom-box">
                  {getRoleNameByProfileId(user.profileId)}
                </span>
              </div>
            </Stack>

            <Stack flexDirection="row">
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  paddingRight: "19px",
                  borderRight:
                    user.accountStatus === "ACTIVE"
                      ? "1px solid #313838"
                      : undefined,
                  margin: "3px 0px",
                  opacity: 1,
                }}
              >
                <FormControlLabel
                  control={
                    <AntSwitch
                      checked={checked}
                      onChange={handleChangeSwitch}
                    />
                  }
                  labelPlacement="start"
                  label={<Typography> </Typography>}
                />
              </Box>
              {user.accountStatus === "ACTIVE" && (
                <img
                  className="icon"
                  src={threeDotsIcon}
                  alt="options"
                  onClick={() => handleToggleDropdown(user.userId)}
                />
              )}
            </Stack>

            {dropdownVisible === user.userId && (
              <ClickAwayListener onClickAway={() => setDropdownVisible(null)}>
                <div
                  className="cardDropdown"
                  style={{
                    top: "20px",
                    maxWidth: "200px !important",
                  }}
                >
                  <Stack
                    display="flex"
                    flexDirection="row"
                    alignItems="center"
                    gap="4px"
                    style={{
                      padding: "8px",
                      cursor: "pointer",
                    }}
                    onClick={() => openEditModal(user.userId)}
                  >
                    <img src={editIcon} alt="edit Icon" />
                    <Typography>Edit</Typography>
                  </Stack>
                  <Stack
                    display="flex"
                    flexDirection="row"
                    alignItems="center"
                    gap="4px"
                    style={{
                      padding: "8px",
                      cursor: "pointer",
                    }}
                    onClick={openDeleteModal}
                  >
                    <img src={deleteIcon} alt="delete Icon" />
                    <Typography>Delete</Typography>
                  </Stack>
                </div>
              </ClickAwayListener>
            )}
          </Stack>
          <div className="userDetails" style={{ marginLeft: "58px" }}>
            <img src={phoneIcon} alt="phone" />
            <div style={{ maxWidth: "150px" }} className="textEllipsis">
              {user.mobile}
            </div>
          </div>
          <div className="userDetails" style={{ marginLeft: "58px" }}>
            <img src={mailIcon} alt="mail" />
            <div
              style={{
                maxWidth: "150px",
                cursor: "pointer",
              }}
              className="textEllipsis"
              title={user.mailId}
            >
              {user.mailId}
            </div>
          </div>
        </Box>
      </Stack>
    </Card>
  );
};

export default UserCardGrid;
